<template>
  <app-modal
    width="40%"
    name="send-email-modal"
    @on-ok="onOk"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    :is-submitting="isLoading"
    :ok-text="$t('actions.form.actions.send')"
    :title="$t('actions.title.SEND_EMAIL')"
  >
    <app-form
      ref="form"
      :schema="schema"
      :layout="layout"
      :data="formModel"
      @on-submit="onSubmit"
    />
  </app-modal>
</template>
<script>
import ToastUtils from '@/utils/toast';
import { regexEmail } from '@/utils/regex';
import AppForm from '@/components/app-form/';
import AppModal from '@/components/app-modal/';
import { PublishedInvoiceProxy } from '@/store/proxies/e-invoice';
import EInvoiceProxy from '../../store/proxies/e-invoice/e-invoice-proxy';

export default {
  name: 'SendEmailModal',
  components: {
    AppForm,
    AppModal,
  },
  data() {
    return {
      filePath: '',
      invoiceId: null,
      invoiceCommonCode: '',
      isLoading: false,
      formModel: {
        name: '',
        email: [],
      },
      schema: {
        name: {
          label: this.$t('actions.form.name.label'),
          placeholder: this.$t('actions.form.name.placeholder'),
          type: 'input',
          disabled: true,
        },
        email: {
          addOnKey: [32, ';', ','],
          label: this.$t('actions.form.email.label'),
          placeholder: this.$t('actions.form.email.placeholder'),
          type: 'tag',
          isShowStar: true,
          notice: this.$t('actions.form.email.info'),
          asyncValidation(value, resolve) {
            if (value.length === 0) {
              resolve({ msg: this.$t('error.form.email.required') });
              return;
            }

            const isValid = value.every((item, index) => {
              if (!regexEmail.test(item.text)) {
                resolve({ msg: `${this.$t('error.form.email.validate')} ${index + 1}` });
                return false;
              }
              return true;
            });

            if (isValid) {
              resolve(true);
            }
          },
        },
      },
      layout: {
        'div.grid.grid-cols-1': {
          div: {
            field: 'name',
          },
          'div:0': {
            field: 'email',
          },
        },
      },
    };
  },
  methods: {
    beforeOpen(params) {
      const {
        buyer_name: buyerName,
        buyer_legal_name: buyerLegalName,
        buyer_email: buyerEmail,
      } = params.model;
      const mailHistories = params.mailHistories || '';
      const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;

      const emailSet = new Set([
        ...mailHistories.match(emailPattern) || [],
        buyerEmail,
      ].filter(Boolean));

      this.formModel = {
        email: [...emailSet].map(email => ({ text: email })),
        name: buyerName || buyerLegalName,
      };
      this.invoiceId = params.invoiceId;
      this.filePath = params.filePath;
      this.invoiceCommonCode = params.invoiceCommonCode;
    },

    beforeClose() {
      this.filePath = '';
      this.invoiceId = null;
      this.isLoading = false;
      this.invoiceCommonCode = '';
      this.formModel = {
        name: '',
        email: [],
      };
    },

    onSubmit(formModel) {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          this.isLoading = true;
          let payload = {
            ...formModel,
            email: formModel.email && formModel.email.length > 0 ? formModel.email.map(item => item.text).join(';') : '',
          };
          if (this.invoiceId) {
            payload.id = this.invoiceId;
            new PublishedInvoiceProxy().sendMailPublishedInvoice(payload)
              .then(() => {
                ToastUtils.showToast('success', this.$t('actions.form.toast.sendEmailSuccess'));
                this.$modal.hide('send-email-modal', { isOk: true });
              })
              .catch((error) => {
                ToastUtils.showToast('error', error.message || error);
              })
              .finally(() => {
                this.isLoading = false;
              });
          } else {
            payload = {
              ...payload,
              file_path: this.filePath,
              buyer_name: payload.name,
              invoice_common_code: this.invoiceCommonCode,
            };
            delete payload.name;
            new EInvoiceProxy().sendEmailPreview(payload)
              .then(() => {
                ToastUtils.showToast('success', this.$t('actions.form.toast.sendEmailSuccess'));
                this.$modal.hide('send-email-modal', { isOk: true });
              })
              .catch((error) => {
                ToastUtils.showToast('error', error.message || error);
              })
              .finally(() => {
                this.isLoading = false;
              });
          }
        }
      });
    },

    onOk() {
      this.$refs.form.submit();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/send-email-modal.vue